import { v4 as uuidv4, v5 as uuidv5 } from 'uuid';

export function generateRoomId(): string {
  return `${randomString(4)}`.toUpperCase();
}

export function generateRemoteClientId(deviceId?: string | null): string {
  return uuidv5(deviceId || uuidv4(), uuidv5.URL);
}

export function randomString(length: number): string {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const encoder = new TextEncoder();
export const decoder = new TextDecoder();

export function isMobileBrowser(): boolean {
  if (typeof navigator !== 'undefined') {
    const ua = navigator.userAgent || (navigator as any).vendor || '';
    if (/android|iphone|ipad|ipod|iemobile|wpdesktop/i.test(ua)) return true;
  }
  if (typeof window !== 'undefined') {
    try {
      const hasCoarsePointer = window.matchMedia('(any-pointer: coarse)').matches;
      const hasTouchEvents = 'ontouchstart' in window;
      if (hasCoarsePointer || hasTouchEvents) return true;
    } catch {
      // ignore
    }
  }
  return false;
}
export async function shareOrCopyLink(params: {
  url: string;
  title?: string;
  text?: string;
}): Promise<'shared' | 'copied' | 'noop'> {
  const { url, title = "Wit's End | AI Fantasy RPG", text = "Join my Wit's End game!" } = params;

  try {
    if (typeof navigator !== 'undefined' && (navigator as any).share && isMobileBrowser()) {
      try {
        await (navigator as any).share({ url, title, text });
        return 'shared';
      } catch (err: any) {
        // If user cancels share sheet, do not fallback to copy
        if (err && (err.name === 'AbortError' || err.name === 'NotAllowedError')) {
          return 'noop';
        }
        // Otherwise, try clipboard fallback
      }
    }

    if (typeof navigator !== 'undefined' && navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
      return 'copied';
    }

    // No supported API available
    return 'noop';
  } catch {
    return 'noop';
  }
}
